export const prod = true;
// export const url = '//apibox.52wansy.cn';
export const url = '//api.gamebox.05zhegame.com';